export default (() => {
    if($('.right-widget').length >= 1) {
        $('footer').addClass('hasWidget')
    }
});



// WEBPACK FOOTER //
// ./scripts/util/fix-paddings.js